import { deepFreeze } from '../../utils/misc_utils';

export const ApiRequestStatusEnum = deepFreeze({
    REJECTED: 'rejected',
    FULFILLED: 'fulfilled',
});
